import { useHistory } from 'react-router-dom';

import './TitleBar.scss';

export interface TitleBarProps {
	title: string;
}
const TitleBar: React.FC<TitleBarProps> = props => {
	const history = useHistory();

	return (
		<div className='titleBar'>
			<span>{props.title}</span>
			<span
				onClick={() => {
					history.goBack();
				}}
			>
				X
			</span>
		</div>
	);
};

export default TitleBar;
